import AssetsManager from '../../../data/AssetsManager'
import DataManager from '../../../data/DataManager'
import OverView from '../../../view/OverView'
import ShipView from './ShipView'
import SpaceView from './SpaceView'
import RouteView from './RouteView'

/**
 * GameViewクラス
 */
class GameView extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	GameView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super();

    console.log('Game');

    //=========初期動作=========

    //App参照
    this.app = DataManager.getData('app');

    //アップデート
    this.app.ticker.add(this.update.bind(this));


    //=========変数定義=========

    const holder = this
    
    //ボタンが押されているかどうかのフラグ
    this.isTapedL = false
    this.isTapedR = false
    



    //=========VIEW初期化=========

    //app参照
    this.app = DataManager.getData('app')

    //コンフィグ
    this.config = AssetsManager.getConfig();

    //初期サイズ
    this.size = {
      width	:this.config.STAGE_WIDTH,
      height	:this.config.STAGE_HEIGHT
    }

    //宇宙配置
    this.space = new SpaceView()
    this.addChild(this.space)

    //コンテナ
    this.container = new PIXI.Container()
    this.addChild(this.container)

    //ルート用コンテナ
    this.routeContainer = new PIXI.Container()
    this.routeContainer.x = this.size.width/2
    this.container.addChild(this.routeContainer)

    //宇宙船配置
    this.ship = new ShipView()
    this.ship.x = this.size.width/2
    this.ship.y = -400
    this.container.addChild(this.ship)
    this.ship.on('MISS', this.miss.bind(this))

    //ヒットエリア配置
    this.haL = new PIXI.Graphics()
    this.haL.beginFill(0x000000)
    this.haL.drawRect(0, 0, this.config.STAGE_WIDTH/2, this.config.STAGE_HEIGHT*2)
    this.haL.endFill()
    this.haL.alpha = 0
    this.addChild(this.haL)
    this.haL.on('touchstart', this.onTap.bind(this))
    this.haL.on('touchend', this.onTapEnd.bind(this))

    this.haR = new PIXI.Graphics()
    this.haR.beginFill(0x000000)
    this.haR.drawRect(this.config.STAGE_WIDTH/2, 0, this.config.STAGE_WIDTH/2, this.config.STAGE_HEIGHT*2)
    this.haR.endFill()
    this.haR.alpha = 0
    this.addChild(this.haR)
    this.haR.on('touchstart', this.onTap.bind(this))
    this.haR.on('touchend', this.onTapEnd.bind(this))

    //スコアボックス配置
    this.scoreBox = new PIXI.Text('SCORE 0',{
      fontFamily  : 'PixelMplus12-Bold',
      fontSize    : 36,
      lineHeight  : 36,
      fill        : 0xffff00,
      align       : 'left',
      padding     : 10
    });
    this.scoreBox.x = 20;
    this.scoreBox.y = 20;
    this.addChild(this.scoreBox)

    //キー入力
    document.body.addEventListener('keydown', this.onKeyDown.bind(this))
    document.body.addEventListener('keyup', this.onKeyUp.bind(this))

    //初期リセット
    this.reset()


    //最初のルート生成（DEBUG）
    // const firstRoute = new RouteView()
    // this.routeContainer.addChild(firstRoute)
  }

  /**
   * リセット
   */
  reset()
  {
    //変数初期化
    this.step = 0
    this.score = 0
    this.distance = 0
    this.isLock = true
    this.frameCount = 0
    this.isDragging = false
    this.isTapedL = false
    this.isTapedR = false

    //ボタン押せなくする
    this.haL.interactive = false
    this.haR.interactive = false

    //データマネージャーにスコア保存
    DataManager.setData('score', this.score)

    //スコアボックス非表示
    this.scoreBox.visible = false
    this.updateScore()

    //船リセット
    this.ship.reset()

    //ルートをリセット
    this.routeContainer.x = this.size.width/2
    while(this.routeContainer.children.length) this.routeContainer.removeChildAt(0)
  }

	// --------------------------------------------------------------------------------------------------------------------------------------
	// --	 開いてスタート
	// --------------------------------------------------------------------------------------------------------------------------------------

  /**
   * 開く
   */
  open()
	{
    //最初のルート生成
    const firstRoute = new RouteView()
    this.routeContainer.addChild(firstRoute)

    //次のルート生成
    const nextRoute = new RouteView(firstRoute)
    this.routeContainer.addChild(nextRoute)
    
    //スタート
    this.start()
  }
  
  /**
   * スタート
   */
  start()
  {
    //ステップ変更
    this.step = 1

    //SE
    AssetsManager.playSound('sound_start')

    //スコア表示
    this.scoreBox.visible = true

    //タッチ入力受付
    this.haL.interactive = true
    this.haR.interactive = true

    //宇宙船スタート
    this.ship.start()
  }



  // --------------------------------------------------------------------------------------------------------------------------------------
	// --	 入力
  // --------------------------------------------------------------------------------------------------------------------------------------
  
  onTap(e)
  {
    if(e.target === this.haL)
    {
      this.isTapedL = true
    }
    else if(e.target === this.haR)
    {
      this.isTapedR = true
    }
  } 

  onTapEnd(e)
  {
    if(e.target === this.haL)
    {
      this.isTapedL = false
    }
    else if(e.target === this.haR)
    {
      this.isTapedR = false
    }
  }

  onKeyDown(e)
  {
    if(this.step != 1) return

    if(e.key === 'ArrowLeft' || e.key === 'z')
    {
      this.isTapedL = true
    }
    else if(e.key === 'ArrowRight' || e.key === 'x')
    {
      this.isTapedR = true
    }
  }

  onKeyUp(e)
  {
    if(this.step != 1) return

    if(e.key === 'ArrowLeft' || e.key === 'z')
    {
      this.isTapedL = false
    }
    else if(e.key === 'ArrowRight' || e.key === 'x')
    {
      this.isTapedR = false
    }
  }


 
  // --------------------------------------------------------------------------------------------------------------------------------------
	// --	 ミス
  // --------------------------------------------------------------------------------------------------------------------------------------

  /**
   * ミス
   */
  miss()
  {
    console.log('MISS')

    //SE
    gsap.delayedCall(0.1, ()=>{
      AssetsManager.stopAllSounds()
      AssetsManager.stopSound('sound_jet')
      AssetsManager.stopSound('sound_walk')
      AssetsManager.playSound('sound_miss')
    })

    //ステップ変更
    this.step = 0

    //宇宙船ミス
    this.ship.miss()

    //ゲームオーバー
    this.gameOver()
  }

  /**
   * ゲームオーバー
   */
  gameOver()
  {
    //ゲームオーバー
    setTimeout(()=>{
      OverView.open(this.score)
    }, 3000)
  }


  // --------------------------------------------------------------------------------------------------------------------------------------
	// --	 アップデート
  // --------------------------------------------------------------------------------------------------------------------------------------
  
  /**
   * アップデート
   */
  update()
  {
    //フレームカウント
    this.frameCount ++

    switch (this.step) {
      case 1:
        this.updateShip()
        this.updateRoute()
        this.space.update(this.ship)
        this.distance += this.ship.shipSpeedY
        this.score = Math.round(this.distance)
        this.updateScore()
        break;
    
      default:
        break;
    }
  }

  /**
   * 宇宙船アップデート
   */
  updateShip()
  {
    //プレイヤー左右の移動速度
    let speed = 0
    if(this.isTapedL && !this.isTapedR)
    {
      speed = -1.5
    }
    else if(!this.isTapedL && this.isTapedR)
    {
      speed = 1.5
    }

    //宇宙船アップデート
    this.ship.update(speed)
  }

  /**
   * ルートのアップデート
   */
  updateRoute()
  {
    //横移動
    this.routeContainer.x -= this.ship.shipSpeedX

    let len = this.routeContainer.children.length
    for(let i=0; i<len; i++)
    {
      //ルート参照
      const route = this.routeContainer.getChildAt(i)

      //縦移動
      route.y += this.ship.shipSpeedY

      //プレイヤーとのヒットテスト
      if(route.hitTestPlayer(this.ship))
      {
        this.miss()
        return
      }

      //新しいルート生成
      if(i == len - 1)
      {
        const routeTopY = route.y - route.height + 10
        if(routeTopY >= -this.app.renderer.height)
        {
          const nextRoute = new RouteView(route)
          this.routeContainer.addChild(nextRoute)
        }
      }
      //画面外のルートは破棄
      else if(route.y >= route.height)
      {
        this.routeContainer.removeChild(route)
        i --
        len --
      }
    }
  }


  // --------------------------------------------------------------------------------------------------------------------------------------
	// --	 スコア関連
  // --------------------------------------------------------------------------------------------------------------------------------------

  updateScore()
  {
    //表示更新
    this.scoreBox.text = 'SCORE ' + this.score;
  }

	// --------------------------------------------------------------------------------------------------------------------------------------
	// --	 リサイズ
	// --------------------------------------------------------------------------------------------------------------------------------------
	
	resize()
	{
    //コンテナの位置
    this.container.y = this.app.renderer.height
	}
    
  // ---------------------------------------------------------------------------------------------------------
}

export default GameView
